import React, { useState } from 'react';

import {
    TextField,
    Box,
    Grid,
    Button,
    CircularProgress,
} from "@material-ui/core";

import Alert from '@material-ui/lab/Alert';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';

import {
    Translate,
} from "src/shared_modules/i18n";

import { withRouter } from "react-router-dom";
import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';


const TokenValidationComponent = (props) => {
    const [code, setCode] = useState("");

    const borderBoxProps = {
        bgcolor: 'background.paper',
        borderColor: '#e6e6e6',
        m: 1,
        border: 1,
        padding: 5,
    };

    return(<React.Fragment>
            <h1><Translate>token.title</Translate></h1>
            <Box borderRadius={4} {...borderBoxProps} bgcolor="#e6e6e6">
                <div className="validationDescriptionContainer">
                    <NotificationImportantIcon fontSize="large" />
                    <p className="validationDescription"><Translate>token.description</Translate></p>
                </div>
            </Box>
            <Box borderRadius={4} {...borderBoxProps}>
                <p className="codeInputDescription"><Translate>token.codeInput</Translate></p>
                <Grid item xs={12} sm={12}>
                    <TextField
                        multiline={false}
                        variant="outlined"
                        fullWidth={true}
                        value={code}
                        inputProps={{ maxLength: 6, style: {height: '50px', textAlign: 'center'} }}
                        onChange={(e)=>{setCode(e.target.value);}}
                    />
                </Grid>
            </Box>
            { props.validateFailed && <div className="user-form-alert"><Alert variant="outlined" severity="error">
                <Translate>token.codeError</Translate>
                </Alert>
            </div>}
            <div className="validationButtonContainer">
                <Button variant="contained"
                    color="secondary"
                     onClick={()=>{props.validate(code); props.trackEvent("System", "submit", "verify_mail_" + props.trackingName);}}
                     type="submit"
                     endIcon={props.isBusy && <CircularProgress color="inherit" size={20} />}
                     >
                     <Translate>token.send</Translate>
                </Button>
            </div>
        </React.Fragment>);
}

export default withRouter(withMatomo(TokenValidationComponent));
